import React from 'react';
import { Button, LabeledInput, AlertNotification } from "@commonsku/styles";
import {oauth} from '../../utils';

const EnableQboMapping = () => {
  const [_response, setResponse] = React.useState<string>('');
  const [error, setError] = React.useState<string>('');
  const [success, setSuccess] = React.useState<string>('');

  return <form action="" onSubmit={async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    setSuccess(''); // Clear previous success messages
    setResponse(''); // Clear previous response

    try {
      const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
      const response = await oauth('POST', 'tech-support', {
        ...formData,
        actionName: 'enable_qbo_mapping',
      });

      const data = response.json;
      setResponse(JSON.stringify(data, null, 2));
      
      if (data.status === 'enabled') {
        setSuccess('QBO mapping has been successfully enabled for this tenant');
      } else if (data.status === 'already_enabled') {
        setSuccess('QBO mapping was already enabled for this tenant');
      }
      
    } catch (err) {
      // Handle specific error cases
      if (err.json?.error) {
        setError(err.json.error);
      } else if (err.response?.status === 404) {
        setError('Tenant not found. Please check the tenant domain key and try again.');
      } else if (err.response?.status === 403) {
        setError('Access denied. You do not have permission to perform this action.');
      } else if (err.response?.status === 400) {
        setError('Invalid request. Please check your input and try again.');
      } else {
        setError('An error occurred while processing your request. Please try again.');
      }
    }
  }}>
    <LabeledInput
      label="Tenant Domain Key"
      placeholder="Enter tenant domain key"
      name="tenant_domain_key"
      type="text"
      required
    />
    <Button type="submit">Enable QBO Mapping</Button>
    
    {error && (
      <AlertNotification alertType="error" style={{marginTop: '10px'}}>
        {error}
      </AlertNotification>
    )}
    
    {success && (
      <AlertNotification alertType="success" style={{marginTop: '10px'}}>
        {success}
      </AlertNotification>
    )}

  </form>;
};

EnableQboMapping.label = `Enable QBO Mapping`;

export default EnableQboMapping; 